import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import { toast } from 'react-toastify';
import api from '../utils/api';

// Cible du lien envoyé par email : /verifier-email?token=...
export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState('pending'); // pending | ok | error
  const [resendEmail, setResendEmail] = useState('');
  const requested = useRef(false);

  useEffect(() => {
    if (!token) { setState('error'); return; }
    if (requested.current) return; // évite la double requête (StrictMode) sur un jeton à usage unique
    requested.current = true;
    api.post('/auth/verify-email', { token })
      .then(() => setState('ok'))
      .catch(() => setState('error'));
  }, [token]);

  const resend = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post('/auth/resend-verification', { email: resendEmail });
      toast.success(data.message);
    } catch {
      toast.error('Erreur, réessayez plus tard');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card card" style={{ textAlign: 'center' }}>
        {state === 'pending' && <p>Confirmation en cours...</p>}

        {state === 'ok' && (
          <>
            <CheckCircle size={44} color="#16a34a" style={{ margin: '0 auto 14px' }} />
            <h2 style={{ marginBottom: 10 }}>Adresse confirmée</h2>
            <p style={{ color: 'var(--text-light)' }}>Votre compte est actif. Vous pouvez vous connecter.</p>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block', marginTop: 16 }}>
              Se connecter
            </Link>
          </>
        )}

        {state === 'error' && (
          <>
            <XCircle size={44} color="#dc2626" style={{ margin: '0 auto 14px' }} />
            <h2 style={{ marginBottom: 10 }}>Lien invalide ou expiré</h2>
            <p style={{ color: 'var(--text-light)', lineHeight: 1.6 }}>
              Ce lien de confirmation n'est plus valable.<br />
              Saisissez votre email pour en recevoir un nouveau.
            </p>
            <form onSubmit={resend} style={{ marginTop: 14 }}>
              <div className="form-group">
                <input type="email" value={resendEmail} onChange={e => setResendEmail(e.target.value)}
                  placeholder="votre@email.fr" required />
              </div>
              <button className="btn btn-primary" style={{ width: '100%' }}>Renvoyer l'email</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
